/**
 * The sidebar's gem, which right after a sign-in shows the owl's thumbs-up
 * for a moment: an overlay on the gem's own 32 px box (nothing moves, and it
 * never takes a click), then the gem again. If the owl can't draw, its
 * fallback is the gem itself.
 *
 * Plan: docs/plans/2026-10-22-owl-waits-everywhere.md (sign-in)
 */
import { useEffect, useState } from 'react';
import { OwlMoment } from '@ruby/owl/react';
import { RubyGemIcon } from './RubyLogo';
import { takeSignedIn } from './signed-in-moment';

/** The thumbs-up lasts 1.2 s; it holds a moment, then the gem is back. */
const THUMBS_UP_MS = 2500;
const OWL = 56;

export function SignInGem() {
  const [welcome, setWelcome] = useState(false);
  // Taken in an effect, never during render: StrictMode's second run finds it
  // spent and leaves the state alone.
  useEffect(() => {
    if (takeSignedIn()) setWelcome(true);
  }, []);
  useEffect(() => {
    if (!welcome) return;
    const t = setTimeout(() => setWelcome(false), THUMBS_UP_MS);
    return () => clearTimeout(t);
  }, [welcome]);

  return (
    <span className="relative inline-flex h-8 w-8 shrink-0">
      <span className={welcome ? 'invisible' : undefined}>
        <RubyGemIcon size={32} />
      </span>
      {welcome && (
        <OwlMoment
          moment="thumbs-up"
          size={OWL}
          fallback={<RubyGemIcon size={32} />}
          style={{ position: 'absolute', left: (32 - OWL) / 2, top: (32 - OWL) / 2, pointerEvents: 'none' }}
        />
      )}
    </span>
  );
}
